export default __webpack_public_path__ + "static/chart-mobile-2-8881ba1fe9cb06226bcbb00b618c266a.webp";